import zhCN from 'antd/lib/locale-provider/zh_CN';
import zhMessages from "../locales/zh-Hans.json";

const ZhLan = {
  messages: {
    ...zhMessages
  },
  antd: zhCN,
  locale: 'hans',
};
export default ZhLan;
